import "./client/client";
import "./static/static";
import "bootstrap-3-typeahead";
import "bootstrap-tagsinput";
import "bootstrap";
import "../../../../node_modules/simplemde/dist/simplemde.min.css";
import SimleMDE from 'simplemde';
import addAutocompletion from './autocompletion';

$(document).ready(function () {

    $('textarea.markdown').each(function () {
        new SimleMDE({
            element: $(this)[0],
            toolbar: ['bold', 'italic', 'heading', '|', 'link', 'table', '|', 'preview'],
        });
    });

    $('.dropdown-toggle').dropdown();

    $('[data-scrollto]').each(function () {
        $(this).bind('click', function () {
            const scrollTo = $($(this).data('scrollto'));
            $('html, body').scrollTop(scrollTo.offset().top)
        });
    });

    /*
     * Multi input selector
     */
    if ($('.multi-inputs-selector').length > 0) {

        // Open right item after return
        $('.multi-inputs-selector input.form-control').each(function () {
            if ($(this).val() != '') {
                $(this).closest('.form-group').addClass('selected');
                $(this).closest('.form-group').find('input[type="radio"]').attr('checked', 'checked');
            }
        });

        // Make item visible after click
        $('.multi-inputs-selector input[type="radio"]').bind('click', function () {

            $('.multi-inputs-selector .form-group').removeClass('selected');

            if ($(this).val() != null) {
                $(this).closest('.form-group').addClass('selected');
            }
        });
    }

    /*
     * Select all checkboxes
     *
     * !! Not used anymore, but available for usage
     *
     */
    if ($('#select-all-checkboxes').length > 0) {

        $('#select-all-checkboxes').bind('click', function () {
            var checked = $(this).prop('checked');

            if (checked == true) {
                $('.form-content .form-group input[type="checkbox"]').each(function () {
                    $(this).prop('checked', true);
                });
            } else {
                $('.form-content .form-group input[type="checkbox"]').each(function () {
                    $(this).prop('checked', false);
                });
            }
        });
    }

    /*
     * Submit form #track-players-form
     */
    if ($('#track-players-form').length > 0) {
        $('#track-players-form input[type="checkbox"]').bind('click', function () {
            $(this).closest('form').submit();
        });
    }

    /*
     * Are you sure button
     */
    $('.delete-animated').on('click', function () {
        $(this).find('span').toggleClass('hidden');
        $(this).find('a').toggleClass('hidden').toggleClass('animated');

        setTimeout(function () {
            $('.delete-animated > span.hidden').toggleClass('hidden');
            $('.delete-animated > a.animated').toggleClass('hidden').toggleClass('animated');
        }, 3000);
    });

    /*
     * Fade icons delete buttons
     */
    $('.delete-fade').bind('click', function () {
        $(this).find('span').toggleClass('hidden');
        $(this).find('a').toggleClass('hidden');

        setTimeout(function () {
            $('.delete-fade').find('span').removeClass('hidden');
            $('.delete-fade').find('a').addClass('hidden');
        }, 3000);
    });

    /*
     * Display the correct merge vars in create mailtemplate form
     */
    $('#template-names select').change(function () {
        var value = $(this).val();
        $('.merge-vars').addClass('hidden');
        $('div#' + value).removeClass('hidden');
    });

    /*
     * Scroll message to last message
     */
    if ($('.list-clean.chat').length > 0) {
        var chat = $('.list-clean.chat');

        var totalHeight = 0;

        $(chat).children().each(function () {
            totalHeight = totalHeight + $(this).outerHeight(true);
        });

        $(chat).scrollTop(totalHeight);
    }

    /*
    * For autocompletion combined with tagsinput
    * Add 'tagsinput' to classlist of input element
    * Add { items: [{value: "value", text: "text"}] } json string to tag as a tag-attribute called 'data-autocompletion-data'
    */
    if ($('.tagsinput').length > 0) {
        $('.tagsinput').each(function () {

            // Initialize
            $(this).tagsinput({
                itemValue: 'value',
                itemText: 'text',
                typeahead: {
                    name: 'tags',
                    displayKey: 'text',
                    source: $(this).attr('data-autocompletion-data') !== undefined ? JSON.parse($(this).attr('data-autocompletion-data')).items : null
                },
                allowDuplicates: true,
                freeInput: true
            });

            // Clear contents after selecting an item
            $(this).on('itemAdded', function (el) {
                setTimeout(function () {
                    // Todo: change when there are multiple items on one page
                    $('.bootstrap-tagsinput').find('input[type=text]').val("");
                }, 1);
            });

            // Set selected values during initialize
            if ($(this).attr('data-selected-data') !== undefined) {
                for(const item  of JSON.parse($(this).attr('data-selected-data')).items) {
                    $(this).tagsinput('add', item);
                }
            }
        });
    }

    /*
     * For sortable lists
     */
    var el = document.getElementById('sortable');
    if (el != null) {
        require(['sortablejs'], function (Sortable) {
            Sortable.create(el, {
                filter: 'a, img, .dropdown, .dropdown-menu',
                animation: 150,
                delay: 0,
                forceFallback: true,
                fallbackClass: 'custom-ghost'
            });
        });
    }

    /*
     * For autocompletion
     * Add 'autocomplete' to classlist of input element
     * Add { items: [] } json string to tag as a tag-attribute called 'data-autocompletion-data'
     */
    $('.autocomplete').each(function() {
        addAutocompletion(this, JSON.parse(this.attributes.getNamedItem('data-autocompletion-data').value).items);
    });

    /*
    * Switch tags form for company
    */
    if ($('#company-select').length > 0) {
        $('#company-select').bind('change', function() {
            var val = $(this).val();

            var formGroup = $('#company-select-form-group');
            if (val !== null) {
                formGroup.removeClass('hidden');
                formGroup.find('.tagsinput-container').addClass('hidden');
                formGroup.find('.tagsinput-container input').attr('disabled', 'disabled');
                var target = $('#tagsinput-container-' + val).removeClass('hidden');
                $(target).find('input').removeAttr('disabled');
            } else {
                formGroup.addClass('hidden');
            }
        });
    }

     /*
      * Switch input when select manual asking categories
      */
    if ($('input[name="categories_search_type"]').length > 0) {
        $('input[name="categories_search_type"]').bind('change', function() {
            var val = $(this).val();

            var formGroup = $('#category-select-form-group');

            formGroup.addClass('hidden');

            if (val !== null && val === 'single') {
                formGroup.removeClass('hidden');
            }
        });
    }

    /*
     * Switch player input when select manual asking categories
     */
    if ($('input[name="player_select_type"]').length > 0) {
        $('input[name="player_select_type"]').bind('change', function() {
            var val = $(this).val();

            var playerFormSearch = $('#player-select-form-group');
            var tagFormSearch = $('#tag-select-form-group');
            var playerResults = $('#player-search-results');

            switch (val) {
                case 'single' :
                    playerFormSearch.removeClass('hidden');
                    tagFormSearch.addClass('hidden');
                    playerResults.removeClass('hidden');
                    break;
                case 'tag' :
                    playerFormSearch.addClass('hidden');
                    tagFormSearch.removeClass('hidden');
                    playerResults.addClass('hidden');
                    break;
                default :
                    playerFormSearch.addClass('hidden');
                    tagFormSearch.addClass('hidden');
                    playerResults.addClass('hidden');
                    break;
            }
        });
    }

    /*
     * Selecting colors in admin
     */
    if ($('[name="color-text"]').length > 0) {
        let input = $('[name="color-text"]');
        let circle = $('[name="color"]');

        input.bind('change', function() {
            let hex = this.value;
            if (isValidHex(hex)) {
                $(circle).val(hex);
            }
        });
        circle.bind('change', function() {
            let hex = this.value;
            if (isValidHex(hex)) {
                $(input).val(hex);
            }
        });
        function isValidHex(hex) {
            if (hex.length < 7 || hex[0] !== '#') {
                return false
            }

            for (var i = 1; i < hex.length; i++) {
                if (isNaN(hex[i]) && !['a', 'b', 'c', 'd', 'e', 'f'].includes(hex[i])) {
                    return false
                }
            }
            return true;
        }
    }

});





// WEBPACK FOOTER //
// ./resources/assets/js/misc/misc.js